<h2 mat-dialog-title>Arrêter les congés de {{ data.employee }}</h2>

<mat-dialog-content>

	<p class="period">Année de congés {{ period }}</p>

	<!-- LE CALCUL — il est fait, il est montré. On ne demande jamais de ressaisir un chiffre
	     que le logiciel connaît : on demande la seule chose qu'il ne peut pas décider. -->
	<div class="calc">
		@if (data.row.carried_in > 0) {
			<div class="calc-line">
				<span class="lbl">Reporté de l'année précédente</span>
				<span class="val">{{ daysLabel(data.row.carried_in) }}</span>
			</div>
		}
		<div class="calc-line">
			<span class="lbl">Acquis sur la période</span>
			<span class="val">{{ daysLabel(data.row.acquired_days) }}</span>
		</div>
		@if (data.row.fractionation_days > 0) {
			<div class="calc-line">
				<span class="lbl">Jours de fractionnement (L3141-23)</span>
				<span class="val">{{ daysLabel(data.row.fractionation_days) }}</span>
			</div>
		}
		<div class="calc-line">
			<span class="lbl">Pris</span>
			<span class="val minus">− {{ daysLabel(data.row.taken_days) }}</span>
		</div>
		<div class="calc-line total">
			<span class="lbl">Solde à arbitrer</span>
			<span class="val">{{ daysLabel(balance) }}</span>
		</div>
	</div>

	@for (w of data.row.warnings; track w) {
		<p class="warn"><mat-icon>info</mat-icon>{{ w }}</p>
	}

	<!-- LA DÉCISION — la seule chose demandée. -->
	<h4>Que fait-on de ces {{ daysLabel(balance) }} ?</h4>
	<!-- D'OÙ VIENT le pré-remplissage. Sans cette phrase, une case cochée sur une fiche et des
	     chiffres inattendus ici n'ont aucun moyen de se rejoindre dans la tête de qui les lit. -->
	<p class="policy">{{ policyLabel }}</p>
	<div class="shortcuts">
		<button mat-stroked-button type="button" (click)="allTo('carry')">Tout reporter</button>
		<button mat-stroked-button type="button" (click)="allTo('lost')">Tout perdre</button>
		<button mat-stroked-button type="button" (click)="allTo('paid')">Tout payer</button>
	</div>

	<!-- `subscriptSizing="dynamic"` : la gouttière du hint fait la hauteur de son texte au lieu
	     d'une ligne fixe. Sans elle, un hint sur deux lignes débordait sur le message d'erreur. -->
	<div class="split">
		<mat-form-field subscriptSizing="dynamic">
			<mat-label>Reporté</mat-label>
			<input matInput type="number" min="0" step="0.5" [(ngModel)]="carried" name="carried" id="closingcarried">
			<span matTextSuffix>j</span>
			<mat-hint>Utilisables sur l'année suivante</mat-hint>
		</mat-form-field>
		<mat-form-field subscriptSizing="dynamic">
			<mat-label>Perdu</mat-label>
			<input matInput type="number" min="0" step="0.5" [(ngModel)]="lost" name="lost" id="closinglost">
			<span matTextSuffix>j</span>
			<mat-hint>Non pris, non reportés</mat-hint>
		</mat-form-field>
		<mat-form-field subscriptSizing="dynamic">
			<mat-label>Payé</mat-label>
			<input matInput type="number" min="0" step="0.5" [(ngModel)]="paid" name="paid" id="closingpaid">
			<span matTextSuffix>j</span>
			<mat-hint>Indemnité compensatrice</mat-hint>
		</mat-form-field>
	</div>

	@if (issue; as msg) {
		<p class="issue"><mat-icon>error_outline</mat-icon>{{ msg }}</p>
	} @else {
		<p class="ok"><mat-icon>check_circle</mat-icon>Répartition complète.</p>
	}

	<mat-form-field class="full" subscriptSizing="dynamic">
		<mat-label>Commentaire</mat-label>
		<input matInput [(ngModel)]="comment" name="comment" id="closingcomment"
			placeholder="Accord du 12/06, report exceptionnel pour arrêt maladie…">
		<mat-hint>Il reste attaché à l'arrêté : c'est lui qui l'expliquera dans trois ans</mat-hint>
	</mat-form-field>

	<p class="legal">
		Les congés non pris à la fin de la période sont en principe <b>perdus</b> (L3141-12 s.). Le
		report suppose un accord, un usage d'entreprise, ou une impossibilité de les prendre du fait
		de l'employeur — la maladie ouvrant un report de 15 mois.
	</p>

</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-button (click)="onCancel()">Annuler</button>
	@if (data.rules.closing_employee_ack) {
		<button mat-stroked-button [disabled]="!valid" (click)="onPropose()"
			matTooltip="Le salarié valide son solde depuis son écran Congés, puis vous clôturez">
			Soumettre au salarié
		</button>
	}
	<button mat-flat-button color="primary" [disabled]="!valid" (click)="onClose()" id="closingvalidate">
		Clôturer
	</button>
</mat-dialog-actions>
